// extracted by mini-css-extract-plugin
module.exports = {"affirm":"AffirmLineBF_affirm__x5O6_","monthly_price":"AffirmLineBF_monthly_price__6dDAw"};